import styled from "styled-components";
import React from "react";
import AutoDecorate from "./AutoDecorate";

interface Props {
  label: React.ReactNode;
  className?: string;
}

const StyledDescription = styled.div`
  color: var(--dark700);
  font-size: 14.5px;
  white-space: pre-wrap;
  padding-top: 5px;
`;

const Description = (props: Props) => {
  const { label, className } = props;
  return (
    <StyledDescription className={className}>
      {typeof label === "string" ? <AutoDecorate text={label} /> : label}
    </StyledDescription>
  );
};

export default Description;
